import { FsMatchTrack } from "db/model/match/Track/FsMatchTrack";
import { CupModePoints } from "model/Match/Set/CupMode/Format/CupModePoints";
import { nonUndefined } from "Utility";
import { mapMatchTrackBase } from "db/mapping/match/Track/FsMatchTrack";
import { mapTrackRounds } from "db/mapping/match/Track/FsTrackRound";
import { mapForwardCupModeRounds } from "../../CupMode/Forward/FsForwardCupModeRound";
import { Scores, applyScoreOverrides } from "model/Scores";
import { CupModeLongTrack } from "model/Match/Set/CupMode/Track/CupModeLongTrack";
import { calculateFinalPositions } from "model/Positions";
import { Roster } from "model/Roster/Roster";
import { RosterScope } from "model/Roster/RosterScope";

export const mapForwardCupModeLongTracks = (
  fsModels: FsMatchTrack[],
  rosters: Roster[],
  rosterScope: RosterScope,
  points: CupModePoints,
  finalist: boolean,
  pointsLimit: number,
  driversPerTeam: number,
  requiredTeamWinners: number | undefined
) => {
  return nonUndefined(
    fsModels.map((t) =>
      mapForwardCupModeLongTrack(
        t,
        rosters,
        rosterScope,
        points,
        finalist,
        pointsLimit,
        driversPerTeam,
        requiredTeamWinners
      )
    )
  );
};

const mapForwardCupModeLongTrack = (
  fsModel: FsMatchTrack,
  rosters: Roster[],
  rosterScope: RosterScope,
  points: CupModePoints,
  finalist: boolean,
  pointsLimit: number,
  driversPerTeam: number,
  requiredTeamWinners: number | undefined
): CupModeLongTrack | undefined => {
  const baseRounds = mapTrackRounds(nonUndefined(fsModel.rounds ?? []));
  const scores: Scores = {};
  const rounds = mapForwardCupModeRounds(
    baseRounds,
    rosters,
    rosterScope,
    scores,
    points,
    finalist,
    pointsLimit,
    driversPerTeam,
    requiredTeamWinners,
    { type: "Finished", num: 1 }, // todo - CupModeLong support dynamic playTillFinished
    [],
    []
  );

  applyScoreOverrides(scores, fsModel.scoreOverrides);

  const isComplete =
    fsModel.overrideComplete ||
    Object.values(scores).some((v) => v > pointsLimit);

  return {
    ...mapMatchTrackBase(fsModel),
    finalPositions: calculateFinalPositions(isComplete, scores, compareScores),
    isComplete,
    rounds,
    scores,
  };
};

const compareScores = (scores: Scores, a: string, b: string) => {
  return scores[b] - scores[a];
};
